function createMessageWithParams(template) {
  return ({ $params, $property }) => {
    let message = template;
    if ($property) {
      message = message.replace(/\{_field_\}/g, String($property));
    }
    if ($params && typeof $params === "object") {
      Object.entries($params).forEach(([key, value]) => {
        const placeholder = new RegExp(`\\{${key}\\}`, "g");
        message = message.replace(placeholder, String(value));
      });
    }
    return message;
  };
}
export default createMessageWithParams;
